import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const painPoints = [{
    icon: '🍔',
    title: 'La comida procesada daña tu microbiota sin que te des cuenta',
    description: 'Los aditivos y conservantes destruyen las bacterias buenas de tu intestino diariamente.'
  }, {
    icon: '😴',
    title: 'El estrés diario inflama tu sistema digestivo por dentro',
    description: 'El cortisol alto altera tu digestión, causando hinchazón y malestar constante.'
  }, {
    icon: '🏃',
    title: 'El ritmo de vida no te deja comer bien ni descansar',
    description: 'Comer a deshoras y rápido impide que tu cuerpo absorba los nutrientes correctamente.'
  }, {
    icon: '💊',
    title: 'Los medicamentos afectan tu flora intestinal protectora',
    description: 'Antibióticos y pastillas comunes arrasan con tu escudo protector natural.'
  }, {
    icon: '🌡️',
    title: 'La inflamación crónica causa cansancio, dolor y envejecimiento acelerado',
    description: 'Un cuerpo inflamado gasta toda su energía intentando sanar, dejándote agotado.'
  }, {
    icon: '🧠',
    title: 'Tu gut-brain connection está afectando tu estado de ánimo',
    description: 'Un intestino poco saludable genera ansiedad, niebla mental y cambios de humor.'
  }];
  return <section className="py-24 bg-[#FAFAF7]" data-id="element-252">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-254">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-255">
            ¿Te Identificas Con Esto?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-256">
            Vivir en USA tiene un costo invisible para tu salud...
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-257">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-258">
              <div className="text-4xl mb-4" data-id="element-259">{point.icon}</div>
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-3 leading-snug" data-id="element-260">
                {point.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-261">
                {point.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto bg-[#1B5E20]/5 p-6 rounded-2xl border border-[#1B5E20]/10" data-id="element-262">
          <p className="text-lg font-medium text-[#1B5E20]" data-id="element-263">
            No es tu culpa. El sistema está diseñado así. Pero hay una solución
            natural...
          </p>
        </motion.div>
      </div>
    </section>;
}